// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c9OZShoHi9EmI4 {
  position: relative;
  min-width: 750px;
  max-width: 880px;
  margin: auto;
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--ds-surface, #ffffff);
}
.hAXf3hXsqrli68 {
  display: block;
  width: 100%;
  border-top-left-radius: var(--ds-border-radius-300, 10px);
  border-top-right-radius: var(--ds-border-radius-300, 10px);
}
.LqYEjssljhuWlj {
  padding: var(--ds-space-400, 32px) var(--ds-space-500, 40px) var(--ds-space-500, 40px);
  text-align: center;
}
.jq3atri82nl0XN {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-500, 40px);
  column-gap: var(--ds-space-100, 8px);
}
.BXDMX5DlO6ZAiO {
  position: absolute;
  top: var(--ds-space-100, 8px);
  right: var(--ds-space-200, 16px);
  color: #ffffff;
}
.BXDMX5DlO6ZAiO:hover,
.BXDMX5DlO6ZAiO:active {
  color: #ffffff;
}
`, ""]);
// Exports
export var gaAnnouncementModal = `c9OZShoHi9EmI4`;
export var headingImage = `hAXf3hXsqrli68`;
export var contentContainer = `LqYEjssljhuWlj`;
export var ctasContainer = `jq3atri82nl0XN`;
export var closeButton = `BXDMX5DlO6ZAiO`;
export default ___CSS_LOADER_EXPORT___;
